var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"send-message-box"},[_c('send-message-x',{attrs:{"uploadAgainDB":_vm.uploadAgainDB,"sendType":5},on:{"onViewRecord":_vm.handleViewRecord}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }